import {
  DistanceFilterDropdown,
} from '@/scopes/search/search/pages/SearchPage/components/Filters/DistanceFilters/DistanceFilterDropdown'

export function DistanceToBeachFilter() {
  return (
    <DistanceFilterDropdown
      filterType="MetersToBeach"
      labelId="distance_to_beach_label"
      analyticsType="distance from sea"
      dataQa="distance-to-beach-filter"
    />
  )
}
